__turbopack_context__.v({
  "action": "FullPageMessage-module__IcJ7rG__action",
  "backdrop": "FullPageMessage-module__IcJ7rG__backdrop",
  "body": "FullPageMessage-module__IcJ7rG__body",
  "card": "FullPageMessage-module__IcJ7rG__card",
  "divider": "FullPageMessage-module__IcJ7rG__divider",
  "footnote": "FullPageMessage-module__IcJ7rG__footnote",
  "fpmFadeInUp": "FullPageMessage-module__IcJ7rG__fpmFadeInUp",
  "fpmSoftPulse": "FullPageMessage-module__IcJ7rG__fpmSoftPulse",
  "icon": "FullPageMessage-module__IcJ7rG__icon",
  "iconWrap": "FullPageMessage-module__IcJ7rG__iconWrap",
  "pulse": "FullPageMessage-module__IcJ7rG__pulse",
  "root": "FullPageMessage-module__IcJ7rG__root",
  "subtitle": "FullPageMessage-module__IcJ7rG__subtitle",
  "title": "FullPageMessage-module__IcJ7rG__title",
});
